import { Link } from "react-router-dom";
import { Logo, MonoLabel } from "../components/kit";
import { openCookieSettings } from "../lib/consent";

const H = ({ children }) => <h2 className="text-[15px] font-bold text-[#181621] mt-8">{children}</h2>;
const P = ({ children }) => <p className="text-[14px] text-[#3F3E3A] leading-relaxed mt-2.5">{children}</p>;

const PrivacyDoc = () => (
  <>
    <P><b>Titolare del trattamento:</b> Believe Media Group S.r.l., Via Diocleziano 344, 80124 Napoli (NA), Italia — P.IVA 10639841211. Contatto: info@believestudio.it.</P>
    <H>Ambito</H>
    <P>Questa informativa spiega come raccogliamo e trattiamo i dati personali quando usi Agenzee su agenzee.it, nel rispetto del Reg. UE 2016/679 (GDPR) e del D.lgs. 196/2003.</P>
    <H>Dati che raccogliamo</H>
    <P>Dati account (nome, email, password cifrata, lingua, identificativi login Google/Apple); dati di fatturazione (piano, crediti, storico; le carte le tratta Stripe, non conserviamo il numero completo); dati del brand che fornisci (sito, logo, colori, font, contenuti — "Brand Brain"); contenuti generati; dati di utilizzo (log, dispositivo, IP, cookie); dati di assistenza.</P>
    <H>Finalità e base giuridica</H>
    <P>Fornire Servizio/account/output e gestire pagamenti/crediti/trial = esecuzione del contratto; email di servizio = contratto; migliorare e mettere in sicurezza il Servizio, prevenire abusi = legittimo interesse; email marketing/newsletter = consenso; obblighi legali/fiscali = obbligo legale.</P>
    <H>Trattamenti AI</H>
    <P>Per generare piani e contenuti inviamo gli input pertinenti a fornitori AI terzi, attualmente OpenAI (inclusa generazione immagini). Non vendiamo i tuoi dati. Gli output sono automatici e possono contenere errori: verificali prima dell'uso.</P>
    <H>Responsabili esterni (sub-processor)</H>
    <P>Emergent (hosting), OpenAI (generazione AI, USA), Stripe (pagamenti, USA/globale), Google e Apple (SSO, USA), fornitore email transazionali, eventuale fornitore analytics.</P>
    <H>Trasferimenti internazionali</H>
    <P>Alcuni fornitori sono fuori UE/SEE (es. USA); i trasferimenti sono coperti da Clausole Contrattuali Standard (SCC) o garanzie equivalenti ex Capo V GDPR. Copia a info@believestudio.it.</P>
    <H>Conservazione</H>
    <P>Dati account/brand finché l'account è attivo; dopo la chiusura, solo il necessario — fatture 10 anni (obbligo fiscale), log fino a 24 mesi.</P>
    <H>I tuoi diritti (artt. 15-22 GDPR)</H>
    <P>Accesso, rettifica, cancellazione, portabilità (export), limitazione, opposizione, revoca del consenso. Reclamo al Garante per la protezione dei dati personali (garanteprivacy.it). Per esercitarli: info@believestudio.it (rispondiamo entro 30 giorni). Dalle impostazioni account puoi esportare i dati e richiedere la cancellazione.</P>
    <H>Sicurezza</H>
    <P>Misure tecniche/organizzative adeguate (cifratura in transito, controlli d'accesso, password cifrate). Notifica violazioni ove previsto.</P>
    <H>Minori</H>
    <P>Servizio non destinato a under 16.</P>
    <H>Modifiche</H>
    <P>Pubblicheremo qui la nuova versione con nuova data; modifiche sostanziali notificate.</P>
    <H>Contatti</H>
    <P>Believe Media Group S.r.l. — info@believestudio.it — Via Diocleziano 344, 80124 Napoli (NA).</P>
  </>
);

const TermsDoc = () => (
  <>
    <H>Chi siamo; accettazione</H>
    <P>Il Servizio è gestito da Believe Media Group S.r.l. Creando un account o usando Agenzee accetti questi Termini. Se lo usi per un'azienda, confermi di essere autorizzato a impegnarla.</P>
    <H>Il Servizio</H>
    <P>Agenzee è uno strumento di marketing AI che produce una direzione marketing (piano media ancorato al budget) e aiuta a produrre contenuti: script, piani editoriali, caroselli, creatività ads, landing page. Le funzioni marcate "in arrivo" non fanno parte del Servizio attuale finché non rilasciate.</P>
    <H>Account</H>
    <P>Fornisci informazioni accurate e custodisci le credenziali; sei responsabile delle attività svolte col tuo account.</P>
    <H>Piani, crediti, trial, pagamenti</H>
    <P>Piani a pagamento fatturati mensilmente o trimestralmente tramite Stripe; prezzi al checkout in EUR IVA esclusa salvo diversa indicazione; la fatturazione trimestrale addebita 2 mesi ogni 3 (1 mese gratis). I crediti sono inclusi in ogni piano, si rinnovano ogni mese e non si accumulano; consumati solo dai contenuti visivi generati (piani, script, testo = gratis). Prova gratuita 7 giorni senza carta. Rinnovi automatici fino a disdetta, con effetto a fine periodo. Rimborsi: non rimborsiamo periodi già fatturati; per i consumatori si applica il diritto di recesso di 14 giorni ex Codice del Consumo, che decade se chiedi l'attivazione immediata del servizio digitale e questo viene pienamente eseguito.</P>
    <H>Uso accettabile</H>
    <P>Niente contenuti illeciti/ingannevoli/dannosi, spam o violazioni di regole di terzi/piattaforme. Possiamo sospendere account che abusano del Servizio o del sistema crediti/trial.</P>
    <H>Contenuti generati da AI</H>
    <P>Output forniti "così come sono", nessuna garanzia di accuratezza/originalità/idoneità. Sei responsabile di verificare e approvare gli output prima di pubblicarli. Ai sensi dell'AI Act UE (art. 50) i contenuti generati/manipolati da AI possono dover essere dichiarati come tali: quando pubblichi gli output sei il "deployer" e sei responsabile di tale informativa.</P>
    <H>Proprietà intellettuale</H>
    <P>Resti titolare dei materiali del brand e degli output che generi; ci concedi una licenza limitata per ospitarli/elaborarli. Siamo titolari del Servizio, software e motori di prompt; ottieni un diritto d'uso non esclusivo e non trasferibile.</P>
    <H>Servizi di terzi</H>
    <P>Il Servizio si appoggia a terzi (OpenAI, Stripe, Emergent), fuori dal nostro controllo.</P>
    <H>Responsabilità</H>
    <P>Servizio "così com'è"; nei limiti di legge escludiamo garanzie implicite e la responsabilità totale è limitata a quanto pagato nei 12 mesi precedenti. Restano impregiudicati i diritti inderogabili dei consumatori.</P>
    <H>Sospensione/cessazione</H>
    <P>Puoi cancellare l'account quando vuoi; possiamo sospendere/cessare per violazione o mancato pagamento.</P>
    <H>Modifiche</H>
    <P>Possiamo aggiornare i Termini; l'uso continuato vale come accettazione.</P>
    <H>Legge applicabile e foro</H>
    <P>Legge italiana; foro di Milano, fatte salve le norme imperative a tutela dei consumatori e il foro del luogo di residenza del consumatore.</P>
    <H>Contatti</H>
    <P>info@believestudio.it.</P>
  </>
);

const CookieDoc = () => (
  <>
    <H>Cosa sono i cookie</H>
    <P>Piccoli file/identificativi salvati sul dispositivo per far funzionare il sito, ricordare preferenze e misurare l'uso.</P>
    <H>Cookie che usiamo</H>
    <P>Strettamente necessari (login/sessione, sicurezza, checkout Stripe) — nessun consenso; funzionali/preferenze (lingua, impostazioni) — consenso; analytics — consenso; marketing (se usati) — consenso.</P>
    <H>Base giuridica</H>
    <P>I necessari operano sul legittimo interesse a fornire il servizio richiesto; tutti gli altri richiedono consenso preventivo (ePrivacy + GDPR + provvedimenti del Garante).</P>
    <H>Gestione del consenso</H>
    <P>Al primo accesso vedi un banner; puoi accettare tutto, rifiutare tutto o scegliere per categoria, e cambiare scelta da "Impostazioni cookie". Puoi anche bloccare i cookie dal browser.</P>
    <button
      onClick={openCookieSettings}
      className="mt-6 rounded-full bg-[#181621] text-[#FAF8F3] text-[13px] font-semibold px-5 py-2.5"
      data-testid="cookie-page-settings-btn"
    >
      Impostazioni cookie
    </button>
  </>
);

const DOCS = {
  privacy: { label: "PRIVACY POLICY", title: "Privacy Policy", body: <PrivacyDoc /> },
  termini: { label: "TERMINI DI SERVIZIO", title: "Termini di Servizio", body: <TermsDoc /> },
  cookie: { label: "COOKIE POLICY", title: "Cookie Policy", body: <CookieDoc /> },
};

export default function LegalPage({ doc }) {
  const d = DOCS[doc];
  return (
    <div className="min-h-screen dot-grid" data-testid={`legal-page-${doc}`}>
      <div className="max-w-3xl mx-auto px-6 py-6">
        <Link to="/"><Logo className="h-5 sm:h-6" /></Link>
      </div>
      <div className="max-w-3xl mx-auto px-6 pb-10">
        <div className="card-soft p-7 sm:p-12">
          <MonoLabel>{d.label}</MonoLabel>
          <h1 className="mt-4 text-3xl sm:text-4xl leading-tight">
            <span className="font-serif-it block">{d.title}</span>
          </h1>
          <p className="mt-3 text-[13px] font-semibold text-[#54505B]" data-testid="legal-effective-date">
            In vigore dal 19 luglio 2026
          </p>
          <div className="mt-2">{d.body}</div>
        </div>
        <div className="mt-8 pb-10 flex flex-wrap items-center gap-x-2 gap-y-1 text-[12px] text-[#54505B]" data-testid="legal-footer-links">
          <Link to="/privacy" className="hover:text-[#181621] underline-offset-2 hover:underline">Privacy</Link>
          <span>·</span>
          <Link to="/termini" className="hover:text-[#181621] underline-offset-2 hover:underline">Termini</Link>
          <span>·</span>
          <Link to="/cookie" className="hover:text-[#181621] underline-offset-2 hover:underline">Cookie</Link>
          <span>·</span>
          <button onClick={openCookieSettings} className="hover:text-[#181621] underline-offset-2 hover:underline">Impostazioni cookie</button>
        </div>
      </div>
    </div>
  );
}
